var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('Breadcrumbs',{staticClass:"my-8 pa-0",attrs:{"items":_vm.breadcrumbsItems}}),_c('ContractData',{attrs:{"is-sub-contract":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }